import { FiSearch, FiBell, FiGlobe, FiDollarSign } from 'react-icons/fi';
import HotelIcon from '../assets/restaurant_icon.svg';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const Header = ({ currency, setCurrency }) => {
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const { t, i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'ta', name: 'Tamil' },
    { code: 'te', name: 'Telugu' },
    { code: 'es', name: 'Spanish' }
  ];

  const changeLanguage = (languageCode) => {
    i18n.changeLanguage(languageCode);
    setShowLanguageDropdown(false);
  };

  const handleCurrencyChange = (e) => {
    const newCurrency = e.target.value;
    if (newCurrency === 'USD') {
      setCurrency({
        symbol: '$',
        code: 'USD',
        locale: 'en-US'
      });
    } else {
      setCurrency({
        symbol: '₹',
        code: 'INR',
        locale: 'en-IN'
      });
    }
  };

  return (
    <header className="bg-white w-full py-3 shadow-sm fixed top-0 left-0 right-0 z-10">
      <div className="px-6 flex justify-between items-center">
        <div className="flex items-baseline">
          <img 
            src={HotelIcon} 
            alt="Hotel Icon" 
            className="w-5 h-5 mr-2 text-gray-800" 
          />
          <h1 className="text-xl font-bold text-gray-800">{t('Curry Keeper')}</h1>
          <span className="ml-2 text-xs bg-gray-100 rounded-full px-2 py-1">{t('manager')}</span>
        </div>
        
        <div className="flex items-center gap-4">
          {/* Currency Selector */}
          <div className="flex items-center gap-1">
            <select
              value={currency?.code || 'INR'}
              onChange={handleCurrencyChange}
              className="text-sm border-none bg-transparent focus:ring-0 focus:border-transparent"
            >
              <option value="INR">INR (₹)</option>
              <option value="USD">USD ($)</option>
            </select>
          </div>
          
          <button className="text-gray-500 hover:text-gray-700 relative">
            <FiBell size={18} />
            <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>
          
          {/* Disabled Language Selector */}
          <div className="relative">
            <button 
              className="text-gray-300 cursor-not-allowed" 
              disabled
              title="Language selection is currently disabled"
            >
              <FiGlobe size={18} />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;